export const MARKETPLACE_SHARE_PLATFORMS = {
  WHATSAPP: "whatsapp",
  LINKEDIN: "linkedin",
  FACEBOOK: "facebook",
  TWITTER: "twitter",
  TELEGRAM: "telegram",
  EMAIL: "email",
  COPY_LINK: "copy_link",
  QR_CODE: "qr_code",
  NATIVE: "native",
};

export function buildAbsoluteShareUrl(path) {
  const value = String(path || "").trim();
  if (!value) return "";
  if (typeof window === "undefined") return value;
  if (/^https?:\/\//i.test(value)) return value;
  return `${window.location.origin}${value.startsWith("/") ? value : `/${value}`}`;
}

export function buildProductSharePath(productId, sharePath) {
  if (sharePath) return sharePath;
  const id = Number(productId);
  if (Number.isFinite(id) && id > 0) return `/marketplace/products/${id}`;
  return "/marketplace/products";
}

export function buildProductSharePayload({
  title,
  shareUrl,
  imageUrl = "",
  companyName = "",
  description = "",
}) {
  const productName = String(title || "this product").trim();
  const supplier = String(companyName || "").trim();
  const summary = String(description || "").trim();
  const image = String(imageUrl || "").trim();

  const lines = [`Check out ${productName} on Trocanet`];
  if (supplier) lines.push(`Supplier: ${supplier}`);
  if (summary) lines.push(summary);
  if (image) lines.push(image);
  lines.push(shareUrl);

  return {
    productName,
    shareUrl,
    imageUrl: image,
    companyName: supplier,
    description: summary,
    fullText: lines.join("\n"),
    shortText: `${productName} — ${shareUrl}`,
    emailSubject: "Check out this product",
    emailBody: lines.join("\n\n"),
  };
}

export function buildWhatsAppShareUrl(payload) {
  return `https://wa.me/?text=${encodeURIComponent(payload.fullText)}`;
}

export function buildFacebookShareUrl(shareUrl) {
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
}

export function buildLinkedInShareUrl(shareUrl) {
  return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
}

export function buildTwitterShareUrl(payload) {
  const params = new URLSearchParams({
    text: payload.productName,
    url: payload.shareUrl,
  });
  return `https://twitter.com/intent/tweet?${params.toString()}`;
}

export function buildTelegramShareUrl(payload) {
  const params = new URLSearchParams({
    url: payload.shareUrl,
    text: payload.productName,
  });
  return `https://t.me/share/url?${params.toString()}`;
}

export function buildEmailShareUrl(payload) {
  const params = new URLSearchParams({
    subject: payload.emailSubject,
    body: payload.emailBody,
  });
  return `mailto:?${params.toString()}`;
}

export function canUseNativeShare() {
  return typeof navigator !== "undefined" && typeof navigator.share === "function";
}

export function isMobileShareDevice() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(max-width: 768px)").matches;
}

export function openShareWindow(url) {
  window.open(url, "_blank", "noopener,noreferrer,width=640,height=520");
}
